<template>
  <div class="big">
    <div class="page_title">调理分类列表</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <el-button
          type="primary"
          @click="addLevelOne"
          :disabled="module_id_array[0]?!module_id_array.includes('594'):false"
        >添加一级分类</el-button>
        <div>
          <el-table
            :data="toningTableData"
            style="width:821px;margin-top: 20px;"
            row-key="conditioning_id"
            border
            default-expand-all
            :tree-props="{children: 'child', hasChildren: 'hasChildren'}"
            :header-cell-style="{background:'#F5F5F5'}"
          >
            <el-table-column
              prop="sort"
              label="排序"
              width="240"
            >
              <template slot-scope="scope">
                <el-input-number
                  v-model="scope.row.sort"
                  style="width:160px"
                  :min="0"
                  :max="1000000000"
                  :controls="false"
                  @change="value=>{return changeSort(value,scope.row.conditioning_id)}"
                  :disabled="module_id_array[0]?!module_id_array.includes('593'):false"
                  label="描述文字"
                ></el-input-number>

              </template>
            </el-table-column>
            <el-table-column
              prop="conditioning_name"
              label="分类名称"
              width="240"
            ></el-table-column>
            <el-table-column
              label="操作"
              width="340"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="addPlan(scope.row)"
                  v-if="scope.row.level==1"
                  :disabled="module_id_array[0]?!module_id_array.includes('594'):false"
                >添加方案</el-button>
                <el-button
                  type="text"
                  @click="editPlan(scope.row)"
                  :disabled="module_id_array[0]?!module_id_array.includes('595'):false"
                >编辑</el-button>
                <el-button
                  type="text"
                  @click="delPlan(scope.row)"
                  :disabled="module_id_array[0]?!module_id_array.includes('596'):false"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <FirstChild
      v-if="firstShow"
      @close="firstShow=false"
      :oldInfo="currentInfo"
    ></FirstChild>
  </div>
</template>
<script>
import toningPlan from '../../../api/toningPlan.js';
import FirstChild from './components/FirstChild';
export default {
  data() {
    return {
      toningTableData: [],
      firstShow: false,
      currentInfo: {},
      category_pic: '',
      category_name: '',
      level2: false,
      imgbox: false,
      currentPage: 1,
      pagesize: 10,
      totalNum: 0
    };
  },
  components: { FirstChild },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      toningPlan.getConditioningCategoryList().then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.toningTableData = data.list;
        }
      });
    },
    //添加一级分类
    addLevelOne() {
      this.currentInfo = { conditioning_id: 0 };
      this.firstShow = true;
    },
    //添加/编辑方案
    addPlan(data) {
      let query = Object.assign(_.omit(data, ['level']), {
        is_add: -1
      });
      this.$router.push({
        path: '/home/imgtext/addOrEditorPlan',
        query
      });
    },
    //编辑分类
    editPlan(data) {
      console.log('编辑', data);
      this.currentInfo = data;
      if (data.level == 2) {
        let query = Object.assign(_.omit(data, ['level']), {
          is_add: 1
        });
        this.$router.push({
          path: '/home/imgtext/addOrEditorPlan',
          query
        });
      } else {
        this.firstShow = true;
      }
    },
    //删除
    delPlan(data) {
      this.$confirm('确定删除吗？', '提示信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          let { conditioning_id, child } = data;
          if (child && child.length) {
            this.$message.warning('分类存在方案，无法删除');
            return;
          }
          let params = {
            conditioning_id
          };
          toningPlan.deleteConditioningInfo(params).then((res) => {
            if (res.code == 0) {
              this.$message.success('删除成功');
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
    //提交保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.ruleForm;
          if (this.title == '添加分类') {
            this.axios
              .post('platform/goods/addGoodsCategory', data)
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success('添加成功');
                  this.add_category = false;
                  this.getList();
                }
              });
          } else {
            let data = this.ruleForm;
            this.axios
              .post('platform/goods/editGoodsCategory', data)
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success('修改成功');
                  this.add_category = false;
                  this.currentInfo = {};
                  this.getList();
                }
              });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //改变排序
    changeSort(value, conditioning_id) {
      if (value) {
        let params = {
          sort: value,
          conditioning_id
        };
        toningPlan.editConditioningCategorySort(params).then((res) => {
          if (res.code == 0) {
            this.$message.success('修改排序成功');
            this.getList();
          }
        });
      } else {
        this.getList();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.big {
  text-align: left;
}
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  padding: 20px;
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  .searchbox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
}
</style>
<style lang="scss">
</style>

